import { Tooltip, TooltipProps } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTouchDevice } from '~/hooks/MediaQueryHook';

import styles from './TooltipContainer.module.scss';

export type TooltipContainerProps = Omit<
  TooltipProps,
  'closeLabel' | 'isTouchDevice' | 'children'
> & {
  children?: TooltipProps['children'];
  showUnderline?: boolean;
  ref?: React.Ref<HTMLElement>;
};

export const TooltipContainer = (props: TooltipContainerProps) => {
  const isTouchDevice = useTouchDevice();
  const { t } = useTranslation('common');

  if (!props.children) {
    return null;
  }

  if (!props.label) {
    return props.children;
  }

  return (
    <Tooltip
      {...props}
      closeLabel={t('common:tapToClose')}
      isTouchDevice={isTouchDevice}
    >
      {props.showUnderline ? (
        <div className={styles.underlineText}>{props.children}</div>
      ) : (
        props.children
      )}
    </Tooltip>
  );
};
